var delta = 8;

module.exports = {
    barrel: {
        symbolsCount: 11,
        symbolNameFormat: "symbol_%d.png",
        blurNameFormat: "blur_%d.png",
        separatedBlurAtlas: true,
        reels: 5,
        rows: 3,
        position: {x: 19 + 2, y: 47},
        cellSize: {width: 190, height: 190},
        reelGap: 8
    },

    symbol_animation_filename_pattern: "symbol_%d",
    lines_filename_pattern: "line_%d",
    frames_filename_pattern: "frame_%d",
    
    /*
    // TODO сделать для случаев когда плашка только с одной стороны линии
    billets_on_filename_pattern: "billet_on_%d.png",
    billets_off_filename_pattern: "billet_off_%d.png",
    billets_coords: [
     {x:1, y:321},
     {x:1, y:152},
     {x:1, y:482},
     {x:1, y:109},
     {x:1, y:520},
     {x:1, y:195},
     {x:1, y:439},
     {x:1, y:276},
     {x:1, y:367},
     {x:1, y:562}],
    */
    left_billets_on_filename_pattern: "billet_on_%d.png",
    left_billets_off_filename_pattern: "billet_off_%d.png",
    left_billets_coords: [
        {x:1, y:321 + delta},
        {x:1, y:152 + delta},
        {x:1, y:482 + delta},
        {x:1, y:109 + delta},
        {x:1, y:520 + delta},
        {x:1, y:195 + delta},
        {x:1, y:439 + delta},
        {x:1, y:276 + delta},
        {x:1, y:367 + delta},
        {x:1, y:562 + delta}],
    
    right_billets_on_filename_pattern: "billet_on_%d.png",
    right_billets_off_filename_pattern: "billet_off_%d.png",
    right_billets_coords: [
        {x:995, y:321 + delta},
        {x:995, y:152 + delta},
        {x:995, y:482 + delta},
        {x:995, y:109 + delta},
        {x:995, y:520 + delta},
        {x:995, y:195 + delta},
        {x:995, y:439 + delta},
        {x:995, y:276 + delta},
        {x:995, y:367 + delta},
        {x:995, y:68 + delta}],
    
    animation_frames_count: [8,8,15,15,12,12,12,12,12,12,18],
    animation_speed: [
        0.2, // павлин
        0.2, // верблюд
        0.2, // тапки
        0.2, // поднос
        0.2, // A
        0.2, // K
        0.2, // Q
        0.2, // J
        0.2, // 10
        0.2, // 9
        0.3  // джин
    ],
    scatter_frames_filename_pattern: "frame_0"
};


//////////////////
// WEBPACK FOOTER
// ./cfg/slot-config.js
// module id = 21
// module chunks = 0